<div class="container py-4 py-md-5" style="max-width: 900px">

  <div *ngIf="loadingPayment" class="loading-overlay">
    <div class="cool-spinner"></div>
    <div class="loading-text">Redirecting to secure checkout…</div>
  </div>

  <div class="card border-0 shadow-lg rounded-4">
    <div class="card-body p-4 p-md-5">

      <!-- Header -->
      <div class="text-center mb-5">
        <h1 class="fw-bold mb-2">Secure Rent Payment</h1>
        <p class="text-muted mb-0">
          One-time or automatic monthly payments
        </p>
      </div>

      <!-- Payment Cadence -->
      <div class="mb-5">
        <label class="form-label fw-semibold mb-3">
          Payment Type
        </label>

        <div class="row g-3">
          <div class="col-12 col-md-6">
            <div
              class="payment-option p-4 rounded-4"
              [class.active]="paymentType === 'one-time'"
              (click)="setPaymentType('one-time')">
              <div class="fw-semibold">One-Time Payment</div>
              <div class="text-muted small mt-1">
                Make a single payment today
              </div>
            </div>
          </div>

          <div class="col-12 col-md-6">
            <div
              class="payment-option p-4 rounded-4"
              [class.active]="paymentType === 'recurring'"
              (click)="setPaymentType('recurring')">
              <div class="fw-semibold">Monthly Auto-Pay</div>
              <div class="text-muted small mt-1">
                Automatically pay every month
              </div>
            </div>
          </div>
        </div>
      </div>

       <!-- Payment Method -->
      <div class="mb-5">
        <label class="form-label fw-semibold mb-3">
          Choose how you’d like to pay
        </label>

        <div class="row g-3">
          <!-- ACH -->
          <div class="col-12 col-md-6">
            <div
              class="payment-option p-4 rounded-4 h-100"
              [class.active]="paymentMethod === 'us_bank_account'"
              (click)="onPaymentMethodChange('us_bank_account')">

              <div class="d-flex justify-content-between align-items-start mb-2">
                <div class="fw-semibold">Bank Account</div>
                <span class="badge bg-success-subtle text-success">
                  Lowest Fee
                </span>
              </div>

              <div class="text-muted small mb-3">
                Secure ACH transfer from your bank
              </div>

              <div class="fw-bold fs-5">
                2% Service Fee
              </div>

              <div class="text-muted small mt-2">
                Typically settles in 3–5 business days
              </div>
            </div>
          </div>

          <!-- Card -->
          <div class="col-12 col-md-6">
            <div
              class="payment-option p-4 rounded-4 h-100"
              [class.active]="paymentMethod === 'card'"
              (click)="onPaymentMethodChange('card')">

              <div class="fw-semibold mb-2">
                Credit / Debit Card
              </div>

              <div class="text-muted small mb-3">
                Visa, Mastercard, AmEx, Apple Pay, Google Pay
              </div>

              <div class="fw-bold fs-5">
                4% Service Fee
              </div>

              <div class="text-muted small mt-2">
                Instant confirmation
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Amount -->
      <div class="mb-4">
        <label class="form-label fw-semibold">
          Payment Amount
        </label>
        <input
          type="number"
          min="1"
          class="form-control form-control-lg"
          [(ngModel)]="baseAmount"
          (input)="onAmountChange(baseAmount)" />
      </div>

      <!-- Summary -->
      <div class="invoice-summary rounded-4 p-4 mb-4">
        <div class="d-flex justify-content-between">
          <span class="text-muted">Payment Amount</span>
          <span>${{ baseAmount.toFixed(2) }}</span>
        </div>

        <div  class="d-flex justify-content-between mt-2">
          <span class="text-muted">
            Service Fee ({{ feePercent * 100 }}%)
          </span>
          <span>${{ feeAmount.toFixed(2) }}</span>
        </div>

        <hr>

        <div class="d-flex justify-content-between fs-5 fw-bold">
          <span>Total</span>
          <span>
            ${{ totalAmount.toFixed(2) }}
          </span>
        </div>
      </div>

      <!-- CTA -->
      <button
        class="btn btn-success btn-lg w-100 py-3 rounded-4"
        (click)="handleSubmit($event)">
        {{ paymentType === 'recurring'
          ? 'Set Up Monthly Auto-Pay'
          : 'Continue to Secure Checkout' }}
      </button>

      <div class="text-center text-muted small mt-4">
        Payments are securely processed by Stripe.
      </div>

    </div>
  </div>
</div>
